import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=7536796f"
import script from "./DeviceDetail.vue?vue&type=script&lang=js"
export * from "./DeviceDetail.vue?vue&type=script&lang=js"
import style0 from "./DeviceDetail.vue?vue&type=style&index=0&id=7536796f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports